import { render, staticRenderFns } from "./vip-container.vue?vue&type=template&id=512f8167&scoped=true&lang=pug&"
import script from "./vip-container.vue?vue&type=script&lang=js&"
export * from "./vip-container.vue?vue&type=script&lang=js&"
import style0 from "./vip-container.vue?vue&type=style&index=0&id=512f8167&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512f8167",
  null
  
)

export default component.exports